import { render, staticRenderFns } from "./WaterCounter.vue?vue&type=template&id=2da6c6ac&"
import script from "./WaterCounter.vue?vue&type=script&lang=js&"
export * from "./WaterCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports